import { createContext, useContext } from 'react';

// types
import type { ReactNode } from 'react';
import type FlightInfoStore from '@tajawal/web-flights-sdk/lib/stores/flight-info.store';

interface ProviderProps {
  children: ReactNode;
  $resources: FlightInfoStore['$resources'];
}

type ServiceContextType = {
  resources: FlightInfoStore['$resources'];
};

const ServiceContext = createContext<ServiceContextType>({} as ServiceContextType);

export function ServiceProvider({ children, $resources }: ProviderProps): JSX.Element {
  return <ServiceContext.Provider value={{ resources: $resources }}>{children}</ServiceContext.Provider>;
}

export function useService(): ServiceContextType {
  return useContext<ServiceContextType>(ServiceContext);
}

export default ServiceContext;
